import { Globals } from "../CoreApp/Globals";
import { ConvertToDate } from "./ConvertToDate";
import { appstr } from "./appstr";
import {
  enumLanguage,
  monthNames,
  abbrmonthNames,
  kFlatFileList,
  enumDateTimeDisplayOptions,
  enumLocaleOptions
} from "../constants";
import { GetCurrentLanguage } from "./GetCurrentLanguage";
import { GetExtension } from "./GetExtension";
import { formatBackendUTCDateString } from "./formatBackendUTCDateString";
import { ZeroLeft } from "./ZeroLeft.js";
import { appstrp } from "./appstrp.js";

Date.prototype.FormatDate = function (dateFormat) {
  var month = this.getMonth();
  var day = this.getDate();
  var year = this.getFullYear();

  if (isNaN(year) || isNaN(day) || isNaN(month)) return appstr("invaliddate");

  var m1 = month + 1;
  var dayS, monthS;
  var stripYear = year === 0;
  switch (dateFormat) {
    case 7:
    case 8:
    case 9:
    case 10:
    case 11:
    case 12:
    case 13:
    case 14:
    case 23:
    case 24:
      //@Dante - check out my Number.Pad method ;)
      monthS = ZeroLeft(m1);
      dayS = ZeroLeft(day);
      break;
    case 15:
      dayS = ZeroLeft(day);
      break;
    default:
      dayS = day.toString();
      monthS = m1.toString();
      break;
  }

  var yearDateS = "";
  var monthDayS = "";

  switch (dateFormat) {
    case 0: // "January 28, 2016"
      monthDayS = appstr(monthNames[month]) + " " + dayS;
      yearDateS = ", " + year;
      break;
    case 1: // "28 January 2016" (in French - 28 janvier 2016)
      var cLanguage = GetCurrentLanguage();
      if (cLanguage != enumLanguage.english)
        monthDayS = dayS + " " + appstr(monthNames[month]).toLowerCase();
      else monthDayS = dayS + " " + appstr(monthNames[month]);
      yearDateS = " " + year;
      break;
    case 2: // "28 Jan 2016"
      monthDayS = dayS + " " + appstr(abbrmonthNames[month]);
      yearDateS = " " + year;
      break;
    case 3: // "1/28/2016"
      monthDayS = monthS + "/" + dayS;
      yearDateS = "/" + year;
      break;
    case 4: // "1-28-2016"
      monthDayS = monthS + "-" + dayS;
      yearDateS = "-" + year;
      break;
    case 5: // "1.28.2016"
      monthDayS = monthS + "." + dayS;
      yearDateS = "." + year;
      break;
    case 6: // "1/28/16"
      monthDayS = monthS + "/" + dayS;
      yearDateS = "/" + year.toString().substr(2, 2);
      break;
    case 7: // "01-28-16"
      monthDayS = monthS + "-" + dayS;
      yearDateS = "-" + year.toString().substr(2, 2);
      break;
    case 8: // "01.28.16"
      monthDayS = monthS + "." + dayS;
      yearDateS = "." + year.toString().substr(2, 2);
      break;
    case 9: // "28/01/2016"
      monthDayS = dayS + "/" + monthS;
      yearDateS = "/" + year;
      break;
    case 10: // "28-01-2016"
      monthDayS = dayS + "-" + monthS;
      yearDateS = "-" + year;
      break;
    case 11: // "28.01.2016"
      monthDayS = dayS + "." + monthS;
      yearDateS = "." + year;
      break;
    case 12: // "28/01/16"
      monthDayS = dayS + "/" + monthS;
      yearDateS = "/" + year.toString().substr(2, 2);
      break;
    case 13: // "28-01-16"
      monthDayS = dayS + "-" + monthS;
      yearDateS = "-" + year.toString().substr(2, 2);
      break;
    case 14: // "28.01.16"
      monthDayS = dayS + "." + monthS;
      yearDateS = "." + year.toString().substr(2, 2);
      break;
    case 15: // "01-2016"
      monthDayS = dayS;
      yearDateS = "-" + year;
      break;
    case 16: // "January 2016"
      monthDayS = appstr(monthNames[month]);
      yearDateS = " " + year;
      break;
    case 17: // "January-2016"
      monthDayS = appstr(monthNames[month]);
      yearDateS = "-" + year;
      break;
    case 18: // "28 (day)"
      monthDayS = dayS;
      break;
    case 19: // "1 (month)"
      monthDayS = monthS;
      break;
    case 20: // "January"
      monthDayS = appstr(monthNames[month]);
      break;
    case 21: // "2016 (year)"
      yearDateS = year;
      break;
    case 22: // "2019/06/19"
      yearDateS = year.toString() + "/";
      monthDayS = monthS.toString() + "/" + dayS.toString();
      break;
    case 23: // "20190619"
      yearDateS = year.toString();
      monthDayS = monthS.toString() + dayS.toString();
      break;
    case 24: // "2019-06-19"
      yearDateS = year.toString() + "-";
      monthDayS = monthS.toString() + "-" + dayS.toString();
      break;
  }
  var dateString = monthDayS + yearDateS;
  if (dateFormat === 22 || dateFormat === 23 || dateFormat === 24)
    dateString = yearDateS + monthDayS;
  if (stripYear) dateString = monthDayS;
  return dateString;
};

Date.prototype.TodayYesterdayString = function () {
  var todayYesterdayString = null;
  var today = new Date();
  var yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  if (today.SameDay(this)) todayYesterdayString = appstr("today");
  else if (yesterday.SameDay(this)) todayYesterdayString = appstr("Yesterday");
  return todayYesterdayString;
};

Date.prototype.convertToUTCNoonDate = function () {
  var utcDate = new Date(
    Date.UTC(this.getUTCFullYear(), this.getUTCMonth(), this.getUTCDate(), 12)
  ); // returns date obj passed in converted to UTC @ time 12 (noon)
  utcDate.applyTimeZoneAndDstOffset(); // applies timezone & dst shift
  return utcDate;
};

Date.prototype.applyTimeZoneAndDstOffset = function () {
  var today = new Date();
  this.setTime(this.getTime() + today.getTimezoneOffset() * 60 * 1000);
  if (today.isDstObserved()) this.addHours(1);
};

Date.prototype.LocalDateToString = function (timeMode, timeFormat) {
  var displayOptions = {
    month: "long",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: (timeFormat ? timeFormat : 12) === 12
  };

  switch (timeMode) {
    case enumDateTimeDisplayOptions.time:
      displayOptions = {
        hour: "numeric",
        minute: "numeric",
        hour12: (timeFormat ? timeFormat : 12) === 12
      };
      break;
    case enumDateTimeDisplayOptions.date:
      displayOptions = { month: "long", day: "numeric", year: "numeric" };
      break;
    case enumDateTimeDisplayOptions.numericdate:
      displayOptions = { month: "numeric", day: "numeric", year: "numeric" };
      break;
    case enumDateTimeDisplayOptions.shortdate:
      displayOptions = { month: "short", day: "numeric", year: "numeric" };
      break;
    case enumDateTimeDisplayOptions.shortdatetime:
      displayOptions = {
        month: "short",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: true
      };
      break;
    case enumDateTimeDisplayOptions.weekdaytime:
      displayOptions = {
        weekday: "short",
        hour: "numeric",
        minute: "numeric",
        hour12: true
      };
      break;
    case enumDateTimeDisplayOptions.todayyesterday:
      var todayYesterdayString = this.TodayYesterdayString();
      if (todayYesterdayString != null) {
        displayOptions = {
          hour: "numeric",
          minute: "numeric",
          hour12: (timeFormat ? timeFormat : 12) === 12
        };
        return (
          todayYesterdayString +
          " " +
          appstrp("at", " ") +
          this.toLocaleString(enumLocaleOptions[Globals._stringMgr.fCurLangStr], displayOptions)
        );
      }
    default:
      break;
  }

  var langCode = Globals._stringMgr.fCurLangStr;
  var locale = enumLocaleOptions[langCode];

  return this.toLocaleString(locale, displayOptions);
};

Date.prototype.convertUTCDateToLocalDateString = function (
  dateString,
  timeString,
  timeFormat,
  timeMode
) {
  var d = formatBackendUTCDateString(dateString);
  if (!timeString && dateString.length === 12) {
    timeString = dateString.substr(dateString.length - 4);
  }

  this.convertUTCDateToLocalDate(d, timeString);

  return this.LocalDateToString(timeMode, timeFormat);
};

Date.prototype.SameDay = function (d2) {
  return (
    this.getFullYear() === d2.getFullYear() &&
    this.getMonth() === d2.getMonth() &&
    this.getDate() === d2.getDate()
  );
};

Date.prototype.GetDayOfWeek = function () {
  var days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  return days[this.getDay()];
};

Date.prototype.stdTimezoneOffset = function () {
  var jan = new Date(this.getFullYear(), 0, 1);
  var jul = new Date(this.getFullYear(), 6, 1);
  return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
};

Date.prototype.isDstObserved = function () {
  return this.getTimezoneOffset() < this.stdTimezoneOffset();
};

Date.prototype.addHours = function (h) {
  this.setTime(this.getTime() + h * 60 * 60 * 1000);
  return this;
};

// expects format yyyy/mm/dd or yyyy-mm-dd or a valid date format for the converttodate fxn to work properly
Date.prototype.convertUTCDateToLocalDate = function (dateString, timeString) {
  var d = ConvertToDate(dateString);
  var today = new Date();

  this.setTime(d + today.getTimezoneOffset() * 60 * 1000);

  if (timeString) {
    var hour = timeString.substring(0, 2);
    var min = timeString.substring(2, 4);

    this.setHours(hour);
    this.setMinutes(min);
  }

  // This takes into account DST
  var offset = this.getTimezoneOffset() / 60;
  var hours = this.getHours();
  this.setHours(hours - offset);
};

Date.prototype.GetBinIDFromDate = function (binDay, useTodayYesterday) {
  var oi = Globals._wsMgr.GetOrgInfo();
  var binID = appstr("notset");
  var dateList = Object.keys(binDay);
  var today = new Date();
  var yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  if (today.SameDay(this))
    binID = useTodayYesterday ? "Today" : today.FormatDate(oi.GetDateFormat());
  else if (yesterday.SameDay(this))
    binID = useTodayYesterday ? "Yesterday" : yesterday.FormatDate(oi.GetDateFormat());
  else {
    for (var d in dateList) {
      var aDate = dateList[d];
      var dateObj = new Date(aDate);
      if (dateObj.SameDay(this)) {
        binID = dateObj.FormatDate(oi.GetDateFormat());
        break;
      }
    }
  }
  return binID;
};

// =================

Object.defineProperty(Array.prototype, "getItem", {
  value: function (item, key, parser) {
    if (typeof parser !== "function") parser = this.parse();
    var isObject = item != null && typeof item === "object";
    var isProp = isObject && key in item;
    return parser(isProp ? item[key] : item);
  }
});

// de-duplicate array
Object.defineProperty(Array.prototype, "unique", {
  value: function () {
    var a = this.concat();
    for (var i = 0; i < a.length; ++i) {
      for (var j = i + 1; j < a.length; ++j) {
        if (a[i] === a[j]) a.splice(j--, 1);
      }
    }
    return a;
  }
});

Object.defineProperty(Array.prototype, "parse", {
  value: function () {
    return function (item) {
      return item;
    };
  }
});

// list sorting - accepts list of objs or flat list of strings
Object.defineProperty(Array.prototype, "sortBy", {
  value: function (
    localeSort,
    key,
    parser,
    autoReverse,
    blanksLast = false,
    manualReverse = false
  ) {
    var reverse = false;
    if (!(this instanceof Array && this.length)) return [];
    var thisList = this;
    if (autoReverse && !manualReverse) {
      var compareList = this.slice();
      // compare using flattened list if list of objs
      compareList = key
        ? compareList.map(function (item) {
            return compareList.getItem(item, key, parser);
          })
        : compareList;
      var sortedList = compareList.sortBy(localeSort);
      var targetList = key
        ? this.map(function (item) {
            return thisList.getItem(item, key, parser);
          })
        : thisList;
      reverse = JSON.stringify(sortedList) === JSON.stringify(targetList);
    }
    if (manualReverse) reverse = manualReverse;
    var desc = !reverse ? 1 : -1;
    return this.sort(function (a, b) {
      a = thisList.getItem(a, key, parser);
      b = thisList.getItem(b, key, parser);
      if (blanksLast) {
        if (a === null || a === "" || typeof a === "object") return 1 * desc;
        if (b === null || b === "" || typeof b === "object") return -1 * desc;
      }
      // localeSort used for localized sorting + numeric sort (file manager folder / file name sorting)
      if (localeSort)
        return (
          desc *
          a.localeCompare(
            b,
            localStorage.language || navigator.languages[0] || navigator.language,
            { numeric: true, ignorePunctuation: true }
          )
        );
      else return desc * (a < b ? -1 : +(a > b));
    });
  }
});

Object.defineProperty(Object.prototype, "GetOverridesKey", {
  value: function (key, fallback) {
    if (this.fOverrides && Object.keys(this.fOverrides).includes(key)) return this.fOverrides[key];
    return fallback;
  }
});

Object.defineProperty(Array.prototype, "shuffle", {
  value: function () {
    for (var i = this.length - 1; i > 0; i--) {
      // Generate random number
      var j = Math.floor(Math.random() * (i + 1));

      var temp = this[i];
      this[i] = this[j];
      this[j] = temp;
    }

    return this;
  }
});

Object.defineProperty(Array.prototype, "GetListIndexByKey", {
  value: function (targetValue, targetKey) {
    var idList = this.map(function (item) {
      return item[targetKey];
    });
    return idList.indexOf(targetValue);
  }
});

Object.defineProperty(Array.prototype, "GetUniqueDuplicateName", {
  value: function (targetName, postFixId, showNumberInParens) {
    var done = false;
    var dupLabel = postFixId != null ? postFixId : " - Copy";
    var counter = 0;
    var uniqueName = targetName;

    if (!this.includes(targetName)) return targetName;

    if (dupLabel.length > 0 && targetName.indexOf(dupLabel) > -1)
      uniqueName = uniqueName.split(/(.*) - Copy(.*)/)[1];

    while (!done) {
      var testName = uniqueName + dupLabel;
      var postFixString = showNumberInParens ? "(" + counter.toString() + ")" : counter.toString();
      if (counter > 0) {
        testName += " " + postFixString;
      }
      if (!this.includes(testName)) done = true;
      else counter++;
    }
    return testName;
  }
});

//======================================================================================================================
Element.prototype.AssignStyle = function (customStyle) {
  var elem = this;
  Object.assign(elem.style, customStyle);
};

Element.prototype.RemoveChildNodes = function () {
  while (this.firstChild) {
    this.removeChild(this.lastChild);
  }
};

//============
String.prototype.shuffle = function () {
  var a = this.split(""),
    n = a.length;

  for (var i = n - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var tmp = a[i];
    a[i] = a[j];
    a[j] = tmp;
  }
  return a.join("");
};

String.prototype.IsFlatFile = function () {
  var fileExt = GetExtension(this);
  var isFlat = kFlatFileList.includes(fileExt);
  return isFlat;
};

//=============
Number.prototype.pad = function (legnth) {
  //Thanks Stack Overflow with this nice method.
  var s = String(this);
  while (s.length < (legnth || 2)) {
    s = "0" + s;
  }
  return s;
};
